var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState, useMemo } from 'react';
import moment from 'moment-timezone';
import { isNull } from 'lodash';
import { List } from './Components/List/List';
import { Modal, ConfirmModal } from './Components/Modal';
import { Legend } from './Components/Legend/Legend';
import { ViewController, getSavedViewMode } from './Components/ViewController/ViewController';
import { Calendar } from './Components/Calendar/Calendar';
import { deleteAllRotations, deleteRotation, processRotations, updateRotation, } from './Context/Rules';
import { calculateDateFromDayIndex } from './utils';
import './styles.css';
function App(_a) {
    var from = _a.from, date = _a.date, isFutureWeek = _a.isFutureWeek, rotations = _a.rotations, contacts = _a.contacts, onChange = _a.onChange, onDateChange = _a.onDateChange, timezone = _a.timezone, isLoading = _a.isLoading, isSaving = _a.isSaving, _b = _a.country, country = _b === void 0 ? 'US' : _b, rotationList = _a.rotationList, onRotationListSave = _a.onRotationListSave, _c = _a.readOnly, readOnly = _c === void 0 ? false : _c, permissions = _a.permissions;
    var _d = useState({
        id: null, index: null, date: null, isOverrideMode: false,
    }), day = _d[0], setDay = _d[1];
    var _e = useState(getSavedViewMode() || 'calendar'), view = _e[0], setView = _e[1];
    var _f = useState(false), showRevertDialog = _f[0], setShowRevertDialog = _f[1];
    var _g = useState(false), showRemoveRotationsDialog = _g[0], setShowRemoveRotationsDialog = _g[1];
    var disabled = isLoading || isSaving;
    // Check if rotation list is set (has primary and final contact)
    var isRotationListSet = !!((rotationList === null || rotationList === void 0 ? void 0 : rotationList.primary_contact) && (rotationList === null || rotationList === void 0 ? void 0 : rotationList.final_contact));
    var hasValidTimezone = Boolean(timezone && moment.tz.zone(timezone));
    var now = hasValidTimezone ? moment().tz(timezone) : moment();
    var handleAddOverride = function () {
        setDay({
            id: null,
            index: -1,
            date: now.format('YYYY-MM-DD'),
            isOverrideMode: true,
        });
    };
    var handleRevertToCalendar = function () {
        setShowRevertDialog(true);
    };
    var confirmRevert = function () {
        onRotationListSave === null || onRotationListSave === void 0 ? void 0 : onRotationListSave(null);
        setShowRevertDialog(false);
        setView('calendar');
    };
    var handleRemoveRotations = function () {
        setShowRemoveRotationsDialog(true);
    };
    var confirmRemoveRotations = function () {
        onChange({ rotation: null, action: 'DELETE_ALL' });
        setShowRemoveRotationsDialog(false);
    };
    var isViewMode = function () {
        if (permissions.update_past_rotations)
            return false;
        if (!day.date)
            return false;
        if (hasValidTimezone)
            return moment.tz(day.date, 'YYYY-MM-DD', timezone).isBefore(now, 'day');
        return moment(day.date, 'YYYY-MM-DD').isBefore(now, 'day');
    };
    var showLoading = isLoading || isSaving;
    var loadingText = isSaving ? 'Saving...' : 'Loading...';
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement(ViewController, { date: date, onDateChange: onDateChange, onAddOverride: handleAddOverride, onRevertToCalendar: handleRevertToCalendar, onRemoveRotations: handleRemoveRotations, showRevertButton: isRotationListSet, disabled: disabled, viewMode: view, onViewModeChange: setView, readOnly: readOnly, permissions: permissions }),
            React.createElement("div", { className: "tech-rotation-content-wrapper" },
                showLoading && (React.createElement("div", { className: "tech-rotation-loading-overlay" },
                    React.createElement("div", { className: "tech-rotation-spinner" },
                        React.createElement("div", { className: "tech-rotation-spinner-icon ".concat(from === 'spp' ? 'spp' : '') }),
                        React.createElement("span", { className: "tech-rotation-spinner-text" }, loadingText)))),
                view === 'list' ? (React.createElement(List, { contacts: contacts, from: from, rotationList: rotationList, onSave: onRotationListSave, readOnly: readOnly })) : (React.createElement(Calendar, { date: date, rotations: rotations, contacts: contacts, disabled: disabled, readOnly: readOnly || isRotationListSet, timezone: timezone, country: country, onClick: function (index, id) {
                        // Check if clicked rotation is an override
                        var clickedRotation = id ? rotations.find(function (r) { return r.id === id; }) : null;
                        var isOverrideClick = (clickedRotation === null || clickedRotation === void 0 ? void 0 : clickedRotation.serviceStatus) === 'override';
                        // Don't open modal if rotation list is set (read-only mode), except for overrides
                        if (isRotationListSet && !isOverrideClick)
                            return;
                        var clickedDate = calculateDateFromDayIndex(index, date, timezone);
                        var clickedDay = hasValidTimezone
                            ? moment(clickedDate).tz(timezone).format('YYYY-MM-DD')
                            : moment(clickedDate).format('YYYY-MM-DD');
                        setDay({ id: id, index: index, date: clickedDay });
                    }, permissions: permissions })))),
        React.createElement(Legend, null),
        React.createElement(Modal, { id: day.id, dayIndex: day.index || 0, isFutureWeek: isFutureWeek, open: !isNull(day.index), fromApp: from, rotations: rotations, contacts: contacts, onClose: function () { return setDay({
                id: null, index: null, date: null, isOverrideMode: false,
            }); }, onChange: onChange, viewMode: isViewMode(), isOverrideMode: day.isOverrideMode, slotDate: day.date || undefined, timezone: timezone }),
        React.createElement(ConfirmModal, { open: showRevertDialog, title: "Revert to Calendar View", message: "This will clear the contact list and restore the calendar-based rotations. Are you sure you want to proceed?", confirmText: "Confirm", cancelText: "Cancel", onConfirm: confirmRevert, onCancel: function () { return setShowRevertDialog(false); }, fromApp: from }),
        React.createElement(ConfirmModal, { open: showRemoveRotationsDialog, title: "Delete All Rotations", message: "This will delete all the rotations in the calendar rotations. Are you sure you want to proceed?", confirmText: "Delete All Rotations", cancelText: "Cancel", onConfirm: confirmRemoveRotations, onCancel: function () { return setShowRemoveRotationsDialog(false); }, fromApp: from })));
}
function TechRotation(_a) {
    var from = _a.from, date = _a.date, rotations = _a.rotations, contacts = _a.contacts, onChange = _a.onChange, onDateChange = _a.onDateChange, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, _c = _a.isSaving, isSaving = _c === void 0 ? false : _c, _d = _a.country, country = _d === void 0 ? 'US' : _d, rotationList = _a.rotationList, onRotationListSave = _a.onRotationListSave, timezone = _a.timezone, _e = _a.readOnly, readOnly = _e === void 0 ? false : _e, _f = _a.permissions, permissions = _f === void 0 ? { update_past_rotations: false, reset_rotations: false } : _f;
    var _g = useState([]), internalRotations = _g[0], setInternalRotations = _g[1];
    // ensure the contact list is always sorted alphabetically by name
    var sortedContacts = useMemo(function () { return __spreadArray([], contacts, true).sort(function (a, b) { return a.name.localeCompare(b.name); }); }, [contacts]);
    var hasValidTimezone = Boolean(timezone && moment.tz.zone(timezone));
    var now = hasValidTimezone ? moment().tz(timezone) : moment();
    var dateMoment = hasValidTimezone
        ? moment.tz(date, 'YYYY-MM-DD', timezone)
        : moment(date, 'YYYY-MM-DD');
    var handleChange = function (_a) {
        var rotation = _a.rotation, action = _a.action;
        var updatedRotations = [];
        if (action === 'UPDATE') {
            updatedRotations = updateRotation(internalRotations, rotation, date);
        }
        if (action === 'DELETE') {
            updatedRotations = deleteRotation(internalRotations, rotation.id);
        }
        if (action === 'DELETE_ALL') {
            updatedRotations = deleteAllRotations(internalRotations);
        }
        setInternalRotations(updatedRotations);
        onChange(updatedRotations);
    };
    useEffect(function () {
        setInternalRotations(processRotations(rotations || [], date));
    }, [rotations, date]);
    var handleDateChange = function (action) {
        var sign = action === 'next' ? 1 : -1;
        var newDate = action === 'today'
            ? now.format('YYYY-MM-DD')
            : dateMoment.clone().add(7 * sign, 'day').format('YYYY-MM-DD');
        onDateChange(newDate);
    };
    return (React.createElement(App, { from: from, date: date, isFutureWeek: dateMoment.isAfter(now, 'week'), contacts: sortedContacts, rotations: internalRotations, isLoading: isLoading, isSaving: isSaving, onChange: handleChange, onDateChange: handleDateChange, timezone: timezone, country: country, rotationList: rotationList, onRotationListSave: onRotationListSave, readOnly: readOnly, permissions: permissions }));
}
export { TechRotation };
//# sourceMappingURL=TechRotation.js.map